import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '@/config/constants';

/**
 * Safety net for misconfigured redirects. If Supabase (or a stale OAuth-app /
 * Site-URL config) sends the user back to ANY route other than /auth/callback
 * with a `?code=` / `?error=` attached, forward it — query string intact — to
 * the callback handler so the session actually gets exchanged, instead of the
 * code sitting on the landing page (the joinwinr.com/?code=… bug).
 *
 * Rendered once at the top of the router tree (see RootLayout).
 */
export function OAuthCallbackCatcher() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === ROUTES.authCallback) return;
    // Fall back to the raw query string in case the router hasn't parsed it yet
    // on the very first paint after the redirect.
    const raw = search || window.location.search;
    const params = new URLSearchParams(raw);
    if (params.has('code') || params.has('error') || params.has('error_description')) {
      navigate(`${ROUTES.authCallback}${raw}`, { replace: true });
    }
  }, [pathname, search, navigate]);

  return null;
}
